<template>
  <v-autocomplete
    no-data-text="Danh sách trống"
    v-bind="this.$attrs"
    item-text="name"
    v-model="schoolYear"
    :items="schoolYears"
    item-value="id"
    outlined
    dense
    hide-details
    @change="onChange"
    v-on:input="$emit('input', $event)"
    :loading="loading"
    clearable
  ></v-autocomplete>
</template>

<script>
import { Generation } from '@/plugins/api'

export default {
  data: () => ({
    schoolYears: [],
    schoolYear: null,
    loading: false,
  }),
  props: {
    filter: Object,
    defaultYear: String,
    options: Object,
  },
  computed: {},
  created() {
    if (this.defaultYear) {
      this.schoolYear = this.defaultYear
    }

    this.fetchAllYears()
  },
  methods: {
    async fetchAllYears() {
      this.loading = true
      this.schoolYears = await Generation.fetch({
        ...this.filter,
        _limit: -1,
        _sort: 'code:DESC',
      })
      this.loading = false
    },
    onChange(data) {
      this.$emit('change', data)
    },
  },
  watch: {
    filter() {
      this.fetchAllYears()
    },
    defaultYear: {
      handler(newVal) {
        this.schoolYear = newVal
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
